import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const uploadImageApi = createAsyncThunk(
  "course/uploadImage",
  async (imageData) => {
    const token = JSON.parse(localStorage.getItem("userData")).token;

    var formData = new FormData();
    formData.append("image_Type", imageData.image_Type);
    formData.append("image", imageData.imagefile);

    return await fetch(
      `${process.env.REACT_APP_VERSEL_API}/api/users/courses-images/update-images/${imageData.courseId}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      }
    )
      .then((res) => res.json())
      .then((resule) => resule)
      .catch((err) => err);
  }
);

const UpdateImageCourseSlicer = createSlice({
  name: "uploadImage",
  initialState: {
    loading: false,
    response: null,
    error: null,
  },
  extraReducers: (builder) => {
    builder.addCase(uploadImageApi.pending, (state, action) => {
      state.loading = true;
    });

    builder.addCase(uploadImageApi.fulfilled, (state, action) => {
      state.loading = false;
      state.response = action.payload;
    });
    builder.addCase(uploadImageApi.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export default UpdateImageCourseSlicer.reducer;
